import { useDateFormatter } from '@bluheadless/ui-logic/src/hooks/useDateFormatter'
import Typography from '../../atoms/typography'

const Date = ({ value, inputTemplate, outputTemplate, forcedLocale, textProps }) => {
	const formattedDate = useDateFormatter(value, inputTemplate, outputTemplate, forcedLocale)
	return <Typography {...textProps}>{formattedDate}</Typography>
}

export default Date
